import { React, useEffect, useState } from "react";
import { listAssignedHospitals } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import Spinner from "../../components/Spinner";
import { useHistory } from "react-router-dom";
const HmisDashboard = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [hospitals, setHospitals] = useState([]);

  useEffect(() => {
    getHospitals();
    return () => {};
  }, []);

  const getHospitals = (e) => {
    setIsLoading(true);
    listAssignedHospitals()
      .then((res) => {
        setIsLoading(false);

        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            setHospitals(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  return (
    <div style={{ padding: '20px', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{ 
          color: '#333', 
          marginBottom: '10px',
          fontSize: '28px',
          fontWeight: 'bold'
        }}>
          HMIS DASHBOARD
        </h1>
        <hr style={{ marginBottom: '30px' }} />

        <h3 style={{ 
          color: '#495057', 
          marginBottom: '25px',
          fontSize: '20px',
          fontWeight: '600'
        }}>
          Select Health Center
        </h3>

        {isLoading && (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px 20px',
            minHeight: '300px'
          }}>
            <Spinner />
            <p style={{
              marginTop: '20px',
              color: '#6c757d',
              fontSize: '16px',
              fontWeight: '500'
            }}>
              Loading health centers...
            </p>
          </div>
        )}

        {!isLoading && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '25px',
            padding: '20px 0'
          }}>
            {hospitals?.map((hospital, i) => {
            return (
              <div
                key={i}
                onClick={() => {
                  history.push({
                    pathname: "/hmis/consultation-rooms",
                    state: hospital,
                  });
                }}
                style={{
                  cursor: 'pointer',
                  height: '200px',
                  animation: `fadeInUp 0.5s ease-out ${i * 0.1}s both`
                }}
              >
                <div
                  className="card text-white"
                  style={{
                    height: '100%',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  {/* Animated background overlay */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)',
                    opacity: 0,
                    transition: 'opacity 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0';
                  }}
                  />
                  
                  <div className="card-body" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '30px',
                    position: 'relative',
                    zIndex: 1
                  }}>
                    <p style={{
                      margin: 0,
                      textAlign: 'center',
                      fontSize: '20px',
                      fontWeight: '600',
                      color: '#fff',
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                      lineHeight: '1.4',
                      wordBreak: 'break-word'
                    }}>
                      {hospital.hospital_name}
                    </p>
                  </div>

                  {/* Decorative corner element */}
                  <div style={{
                    position: 'absolute',
                    top: '-50px',
                    right: '-50px',
                    width: '150px',
                    height: '150px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    transition: 'transform 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                  />
                </div>
              </div>
            );
          })}
          </div>
        )}

        {hospitals?.length === 0 && !isLoading && (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#6c757d'
          }}>
            <p style={{ fontSize: '18px' }}>No health centers available</p>
          </div>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default HmisDashboard;
